import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardHeader,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBIcon,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,

} from 'mdb-react-ui-kit';
import Helper from '../../Helper';

import moment from 'moment';
import Alert from './dialog'
import Search from './search'

import { Stack, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';


const Component = () => {
  const alert = useRef();
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const setError = (message, ismessage) => (ismessage ? alert.current.showmessage(message) : alert.current.showerror(message));
  const [transportJobListExpense, setTransportJobListExpense] = useState([]);
  const [transportJobList, setTransportJobList] = useState([]);
  const [iconsActive, setIconsActive] = useState('income');
  const getcustomer = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getCustomers`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setCustomers([{ text: '', value: 0 }, ...data.Customers]);

      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch user');
      }
    } catch (err) {
      setError('An error occurred while fetching user.');
    }
  }

  useEffect(() => {
    // Get the token from sessionStorage


    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }

    if (!["admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }
    getcustomer();

  }, []);
  const fetchTransportJobListOverdue = async (selectedcustomer, dateFrom, dateTo) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccountSummaryoverdue`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ selectedcustomer, dateFrom, dateTo, }),

      });

      if (response.ok) {
        const data = await response.json();
        setTransportJobList(data.transport_account);
        setTransportJobListExpense(data.transport_expense);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  };

  const fetchTransportJobList = async (dateFrom, dateTo, selectedcustomer) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccountSummary`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo, selectedcustomer }),

      });

      if (response.ok) {
        const data = await response.json();
        setTransportJobList(data.transport_account);
        setTransportJobListExpense(data.transport_expense);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  };
  const fetchTransportJobList_excel = async (dateFrom, dateTo, selectedcustomer) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccountSummary_export`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo, selectedcustomer }),

      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `customer_summary_${dateFrom}_to_${dateTo}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to export summary');
      }
    } catch (err) {
      setError('An error occurred while export summary.');
    }
  };

  let numOr0 = n => isNaN(n) ? 0 : n
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }

    setIconsActive(value);
  };

  return (<>

    <MDBContainer fluid className="my-3">
      <Alert ref={alert} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">

            <MDBCardBody>
              <MDBRow className='mb-3'>
                <MDBCol md='12'>
                  {customers.length > 0 && <Search customers={customers} search={fetchTransportJobList} search2={fetchTransportJobListOverdue} exportexcel={fetchTransportJobList_excel} />}
                </MDBCol>
              </MDBRow>
              <MDBRow className='mb-3'>
                <MDBCol md='2'>
                  <MDBCard>
                    <MDBCardBody>
                      <MDBCardTitle>สรุปรายรับ</MDBCardTitle>
                      <MDBCardText className='text-success fw-bold' >
                        {Helper.formatnumber(transportJobList.filter(el=>el.statusid==3 && el.totalnetamount != null).map(el=>el.totalnetamount).reduce((a, b) => parseFloat(numOr0(a)) + parseFloat(numOr0(b)), 0))} บาท
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
                <MDBCol md='2'>
                  <MDBCard>
                    <MDBCardBody>
                      <MDBCardTitle>สรุปรายจ่าย</MDBCardTitle>
                      <MDBCardText className='text-danger fw-bold' >
                        {Helper.formatnumber(transportJobListExpense.filter(el=>el.statusid==3 && el.totalnetamount != null).map(el=>el.totalnetamount).reduce((a, b) => parseFloat(numOr0(a)) + parseFloat(numOr0(b)), 0))} บาท
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
              </MDBRow>
              <MDBRow className='mb-3'>
                <MDBCol md='12'>
                  <MDBTabs className='mb-3'>
                    <MDBTabsItem>
                      <MDBTabsLink onClick={() => handleIconsClick('income')} active={iconsActive === 'income'}>
                        <MDBIcon fas icon='chart-pie' className='me-2' /> รายรับ
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink onClick={() => handleIconsClick('outcome')} active={iconsActive === 'outcome'}>
                        <MDBIcon fas icon='chart-line' className='me-2' /> รายจ่าย
                      </MDBTabsLink>
                    </MDBTabsItem>
                  </MDBTabs>

                  <MDBTabsContent>
                    <MDBTabsPane open={iconsActive === 'income'}>
                      <MDBTable align='middle'>
                        <MDBTableHead>
                          <tr>
                            <th scope='col'>ลูกค้า</th>
                            <th scope='col'>สถานะ</th>
                            <th scope='col'>วันที่</th>
                            <th scope='col'>วันครบกำหนด</th>
                            <th scope='col' style={{ textAlign: "right" }}>ยอดชำระ</th>
                            <th scope='col' style={{ textAlign: "right" }}>ยอดทั้งหมด</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {transportJobList.map((row, i) => (<tr key={i}>
                            <td>{row.customername}</td>
                            <td>{row.status}</td>
                            <td>{moment(row.jobdateobj).format("DD/MM/YYYY")}</td>
                            <td className={moment(row.duedateobj) < moment() && row.statusid != 3 ? 'text-danger fw-bold' : ''}>{row.duedateobj && moment(row.duedateobj).format("DD/MM/YYYY")}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.totalpaidamount)}</td>
                            <th style={{ textAlign: "right" }}>{Helper.formatnumber(row.totalnetamount)}</th>
                          </tr>))}

                        </MDBTableBody>
                      </MDBTable>

                    </MDBTabsPane>
                    <MDBTabsPane open={iconsActive === 'outcome'}>

                      <MDBTable align='middle'>
                        <MDBTableHead>
                          <tr>
                            <th scope='col'>ลูกค้า</th>
                            <th scope='col'>สถานะ</th>
                            <th scope='col'>วันที่</th>
                            <th scope='col'>วันครบกำหนด</th>
                            <th scope='col' style={{ textAlign: "right" }}>ยอดชำระ</th>
                            <th scope='col' style={{ textAlign: "right" }}>ยอดไม่คิดเงิน</th>
                            <th scope='col' style={{ textAlign: "right" }}>ยอดทั้งหมด</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {transportJobListExpense.map((row, i) => (<tr key={i}>
                            <td>{row.customername}</td>
                            <td>{row.status}</td>
                            <td>{moment(row.jobdateobj).format("DD/MM/YYYY")}</td>
                            <td className={moment(row.duedateobj) < moment() && row.statusid != 3 ? 'text-danger fw-bold' : ''}>{row.duedateobj && moment(row.duedateobj).format("DD/MM/YYYY")}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.totalpaidamount)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.totalnotbillamount)}</td>
                            <th style={{ textAlign: "right" }}>{Helper.formatnumber(row.totalnetamount)}</th>
                          </tr>))}

                        </MDBTableBody>
                      </MDBTable>
                    </MDBTabsPane>

                  </MDBTabsContent>

                </MDBCol>
              </MDBRow>
            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>



    </MDBContainer>
  </>);
};

export default Component;
